/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_8_TitleInputs */

const en_gc_search_guides_what_is_gridcraft_sections_8_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What should you know before relying on it?`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_8_title = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正式依赖它之前，还需要了解什么？`)
};

/**
* | output |
* | --- |
* | "What should you know before relying on it?" |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_8_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_8_title = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_8_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_8_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_8_title(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_8_title(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_8_title as "gc.search_guides.what_is_gridcraft.sections.8.title" }